import * as React from 'react';
import Button from '../common/Button';
import ALDropdown from './components/ALDropdown';
import './AddToListMenu.scss';
import ProductModel from 'src/model/product.model';
import { CartItemModel } from 'src/model/cartItem.model';
import i18n from 'src/translation/i18n';

export interface IAddToListMenuProps {
  label?: string;
  width?: string;
  height?: string;
  className?: string;
  direction?: 'top' | 'bottom';
  part: ProductModel | CartItemModel;
  isLoggedIn: boolean;
  favorite?: boolean;
  loadLists: () => void;
  reloadOrigin?: () => void;
}

export interface IAddToListMenuState {
  isOpen: boolean;
}

export class AddToListMenu extends React.Component<
  IAddToListMenuProps,
  IAddToListMenuState
> {
  private selectRef: any = null;

  public state: IAddToListMenuState = {
    isOpen: false
  };

  private handleClickOutside = (e: any) => {
    if (this.selectRef == null || this.selectRef.contains == null) {
      return;
    }
    if (this.selectRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      isOpen: false
    });
  };

  public componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.loadLists();
    }
  }

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private handleToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  private renderDropdown = () => {
    return (
      <ALDropdown
        part={this.props.part}
        direction={this.props.direction}
        isLoggedIn={this.props.isLoggedIn}
        reloadOrigin={this.props.reloadOrigin}
        favorite={this.props.favorite}
      />
    );
  };

  public render() {
    return (
      <div className="rp-add-to-list" ref={ref => (this.selectRef = ref)}>
        <Button
          label={
            this.props.label
              ? this.props.label
              : `${i18n.t('common.addToList')}`
          }
          textTransform="uppercase"
          height={this.props.height ? this.props.height : '56px'}
          width={this.props.width ? this.props.width : 'auto'}
          buttonClass={`secondary-button ${this.props.className}`}
          icon={{ position: 'right', icon: 'rpds-expand-more' }}
          action={this.handleToggle}
        />
        {this.state.isOpen ? this.renderDropdown() : null}
      </div>
    );
  }
}
